import {
  Box,
  Flex,
  Avatar,
  HStack,
  Link,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  Img,
} from '@chakra-ui/react';
import resume from "../images/Umerbin_Farooq_Resume.pdf";
import { HamburgerIcon, CloseIcon, DownloadIcon } from '@chakra-ui/icons';
import "../App.css";
import image from "../images/Untitled_design-removebg-preview.png"
const NavLink = ({ children }) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700'),
    }}
    href={'#'}>
    {children}
  </Link>
);

export default function Navbar({home,about,skill,project,contact}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const scroll=(elementRef)=>{
    window.scrollTo({
      top:elementRef.current.offsetTop-150,
      behavior:"smooth"
    })
  }
 
  return (
    <div style={{zIndex:200,display:"block"}}>
      <Box bg={useColorModeValue('blue.300', 'blue.300')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'} width="100%" display={"flex"} justifyContent={{lg:"space-between"}}>
            <Img marginTop={"40px"} width={{base:"150px",sm:"150px",md:"150px",lg:"190px"}} onClick={()=>{scroll(home)}} className='image' src={image} alt='NA'/>
            <HStack
              as={'nav'}
              spacing={{sm:"1",md:"1",lg:"4"}}
              display={{ base: 'none', md: 'flex' }}>
              <button className='button' style={{fontSize:'20px',fontWeight:'bold',fontFamily:"cursive",boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px",padding:"15px 10px"}} onClick={()=>scroll(home)}>Home</button>
              <button className='button' style={{fontSize:'20px',fontWeight:'bold',fontFamily:"cursive",boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px",padding:"15px 10px"}} onClick={()=>scroll(about)}>About</button>
              <button className='button' style={{fontSize:'20px',fontWeight:'bold',fontFamily:"cursive",boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px",padding:"15px 10px"}} onClick={()=>scroll(skill)}>Skills</button>
              <button className='button' style={{fontSize:'20px',fontWeight:'bold',fontFamily:"cursive",boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px",padding:"15px 10px"}} onClick={()=>scroll(project)}>Projects</button>
              <button className='button' style={{fontSize:'20px',fontWeight:'bold',fontFamily:"cursive",boxShadow:"rgba(0, 0, 0, 0.35) 0px 5px 15px",padding:"15px 10px"}} onClick={()=>scroll(contact)}>Contacts</button>
              <a onClick={()=>window.open("https://drive.google.com/file/d/18rjVQSOgXOMF3OFE-nS_Fz0jgIQH44q_/view?usp=share_link")} href={resume} download="Umerbin_Farooq_Resume.pdf.pdf">
              <Button colorScheme='blue' fontSize={{sm:"10px",md:"15px",lg:"15px"}}>
              My Resume<DownloadIcon /> 
              </Button></a>
            </HStack>
          </HStack>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              <button onClick={()=>{scroll(home);onClose()}}>Home</button>
              <button onClick={()=>{scroll(about);onClose()}}>About Me</button>
              <button onClick={()=>{scroll(skill);onClose()}}>Skills</button>
              <button onClick={()=>{scroll(project);onClose()}}>Projects</button>
              <button onClick={()=>{scroll(contact);onClose()}}>Contacts</button>
              <a onClick={()=>window.open("https://drive.google.com/file/d/18rjVQSOgXOMF3OFE-nS_Fz0jgIQH44q_/view?usp=share_link")} href={resume} download="umerbin_farooq_resume.pdf.pdf">
              <Button colorScheme='blue' fontSize={"18px"}>
              My Resume<DownloadIcon /> 
              </Button></a>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </div>
  );
}